/**
 * Header search: opens a <dialog> and fetches live results from Shopify's
 * native predictive search route (Search & Discovery, no external service).
 */
(() => {
  const trigger = document.querySelector('[data-search-trigger]');
  const drawer = document.querySelector('[data-search-drawer]');
  if (!trigger || !drawer) return;

  const input = drawer.querySelector('[data-search-input]');
  const closeBtn = drawer.querySelector('[data-search-close]');
  const resultsEl = drawer.querySelector('[data-search-results]');
  const skeletonTemplate = drawer.querySelector('[data-search-skeleton]');

  let debounceTimer;
  let activeController;

  function showSkeleton() {
    if (!skeletonTemplate) return;
    resultsEl.innerHTML = '';
    for (let i = 0; i < 3; i += 1) {
      resultsEl.appendChild(skeletonTemplate.content.cloneNode(true));
    }
  }

  function openDrawer() {
    drawer.showModal();
    input.focus();
  }

  function closeDrawer() {
    drawer.close();
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });
  drawer.addEventListener('cancel', () => closeDrawer());

  function renderResults(products) {
    if (!products.length) {
      resultsEl.innerHTML = `<p class="search-drawer__empty">${window.SEARCH_STRINGS?.noResults || 'No results found.'}</p>`;
      return;
    }

    resultsEl.innerHTML = products
      .map(
        (product) => `
        <a class="search-drawer__result" href="${product.url}">
          ${
            product.image
              ? `<img src="${product.image}" alt="" width="48" height="48" loading="lazy">`
              : ''
          }
          <span>
            <span class="search-drawer__result-title">${product.title}</span><br>
            <span class="search-drawer__result-price">${product.price}</span>
          </span>
        </a>`
      )
      .join('');
  }

  async function fetchResults(term) {
    if (activeController) activeController.abort();
    activeController = new AbortController();

    showSkeleton();

    const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku`;

    try {
      const response = await fetch(url, { signal: activeController.signal });
      if (!response.ok) throw new Error('Search request failed');
      const data = await response.json();
      const products = (data.resources?.results?.products || []).map((product) => ({
        url: product.url,
        title: product.title,
        image: product.image,
        price: product.price,
      }));
      renderResults(products);
    } catch (error) {
      if (error.name !== 'AbortError') {
        resultsEl.innerHTML = `<p class="search-drawer__empty">${window.SEARCH_STRINGS?.error || 'Something went wrong. Try again.'}</p>`;
      }
    }
  }

  input.addEventListener('input', () => {
    const term = input.value.trim();
    clearTimeout(debounceTimer);

    if (term.length < 2) {
      resultsEl.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(() => fetchResults(term), 250);
  });
})();
